export enum STORAGE_TYPE {
  local = 'localStorage',
  session = 'sessionStorage',
}

function useStorage() {
  const storageType = (type: STORAGE_TYPE) =>
    STORAGE_TYPE.local === type ? type : STORAGE_TYPE.session;

  const isBrowser = (() => typeof window !== 'undefined')();

  const getItem = (key: string, type: STORAGE_TYPE) =>
    isBrowser ? window[storageType(type)][key] : '';

  const setItem = (key: string, value: any, type: STORAGE_TYPE) => {
    if (isBrowser) {
      window[storageType(type)].setItem(key, value);
      return true;
    }

    return false;
  };

  const removeItem = (key: string, type: STORAGE_TYPE) => {
    window[storageType(type)].removeItem(key);
  };

  return {
    getItem,
    setItem,
    removeItem,
  };
}

export default useStorage;
